import { Extension } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';

// SlashCommand — typing "/" opens an inline command menu. Items are supplied
// by the host (ChapterEditor) so role-gated entries (e.g. hidden block) can
// be filtered without forking the extension.
//
// `render` is a factory the host provides to drive a React popup; it must
// return the standard suggestion lifecycle hooks (onStart/onUpdate/
// onKeyDown/onExit).
const SlashCommand = Extension.create({
  name: 'slashCommand',

  addOptions() {
    return {
      suggestion: {
        char: '/',
        startOfLine: false,
        allowSpaces: false,
        command: ({ editor, range, props }) => {
          props.command({ editor, range });
        },
        items: () => [],
      },
    };
  },

  addProseMirrorPlugins() {
    return [Suggestion({ editor: this.editor, ...this.options.suggestion })];
  },
});

export default SlashCommand;
